import type { SetDef, TraitDef, UnitDef } from "./types.js";

export interface BoardUnitRef {
  unitId: string;
  /** id do branch escolhido (ex.: Eevee -> "vaporeon") */
  branch?: string;
}

export interface ActiveTrait {
  key: string;
  count: number;
  /** índice do breakpoint ativo (-1 = inativo) */
  tier: number;
  def: TraitDef;
}

/** Traits efetivos de uma unidade, considerando o branch escolhido. */
export function unitTraits(unit: UnitDef, branch?: string): { traits: string[]; cls: string } {
  if (branch && unit.branches) {
    const b = unit.branches.find((x) => x.id === branch);
    if (b) return { traits: [...unit.traits, ...b.addTraits], cls: b.class };
  }
  return { traits: unit.traits, cls: unit.class };
}

/**
 * Conta traits do tabuleiro. Como no TFT, cada LINHA conta uma vez
 * (duas cópias de Pikachu no tabuleiro = 1 Elétrico).
 */
export function computeActiveTraits(board: readonly BoardUnitRef[], set: SetDef): ActiveTrait[] {
  const byId = new Map(set.units.map((u) => [u.id, u]));
  const seen = new Set<string>();
  const counts = new Map<string, number>();

  for (const ref of board) {
    const key = `${ref.unitId}:${ref.branch ?? ""}`;
    if (seen.has(ref.unitId) || seen.has(key)) continue;
    seen.add(ref.unitId);
    const unit = byId.get(ref.unitId);
    if (!unit) throw new Error(`Unidade desconhecida: ${ref.unitId}`);
    const { traits, cls } = unitTraits(unit, ref.branch);
    for (const t of [...traits, cls]) counts.set(t, (counts.get(t) ?? 0) + 1);
  }

  const result: ActiveTrait[] = [];
  for (const [key, count] of counts) {
    const def = set.traits[key];
    if (!def) continue;
    let tier = -1;
    def.breakpoints.forEach((bp, i) => {
      if (count >= bp) tier = i;
    });
    result.push({ key, count, tier, def });
  }
  // ativos primeiro, depois por contagem
  return result.sort((a, b) => b.tier - a.tier || b.count - a.count || a.key.localeCompare(b.key));
}
